(function () {
  var STORAGE_PREFIX = 'pl_dyn_';

  function pickCount(productId, min, max) {
    var key = STORAGE_PREFIX + productId;
    var stored;
    try { stored = sessionStorage.getItem(key); } catch (_) {}
    var parsed = parseInt(stored, 10);
    if (isFinite(parsed) && parsed >= min && parsed <= max) return parsed;
    var next = Math.floor(Math.random() * (max - min + 1)) + min;
    try { sessionStorage.setItem(key, String(next)); } catch (_) {}
    return next;
  }

  function applyDynamicCount() {
    var roots = document.querySelectorAll(
      '[data-people-looking-dynamic-root]:not([data-dynamic-applied="true"])'
    );

    for (var i = 0; i < roots.length; i++) {
      var root      = roots[i];
      var min       = parseInt(root.dataset.dynamicMin, 10);
      var max       = parseInt(root.dataset.dynamicMax, 10);
      var productId = root.dataset.productId;
      var textEl    = root.querySelector('.people-looking__text');

      if (!textEl || !productId || !isFinite(min) || !isFinite(max) || min > max) {
        root.dataset.dynamicApplied = 'true';
        continue;
      }

      textEl.innerHTML = textEl.innerHTML.replace(/\d+/, pickCount(productId, min, max));
      root.dataset.dynamicApplied = 'true';
    }
  }

  function init() {
    applyDynamicCount();

    // Re-apply when the theme re-renders variant options (size/color switch)
    new MutationObserver(function () {
      applyDynamicCount();
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
